import { Controller } from '@hotwired/stimulus';
import { isModalShown, onModalShow } from '../shared/modal/current';

// MVK-3407 — modal "Rạp chiếu" (#cinemaModal), thay Vue `Cinemas`. Fragment Twig theo tỉnh
// (RegionController::cinemasFragment), tải khi modal MỞ lần đầu (MVK-3385); đổi tỉnh trong ô chọn thì nạp lại.
// Như Vue cũ: tỉnh ban đầu lấy từ cookie, đổi tỉnh trong modal KHÔNG ghi cookie.
//
// MVK-3905 — dùng chung cho trang Bootstrap lẫn Flowbite: modal đi qua shared/modal/current.js, class ẩn do markup khai trên
// phần tử `data-controller` (`data-cinema-list-hidden-class`), xem region_picker_controller.js.
export default class extends Controller {
    static targets = ['search', 'item'];
    // `url` chứa `__ID__` thay bằng id tỉnh.
    static values = { url: String, modal: String };
    static classes = ['hidden'];
    static root = null;

    connect() {
        this.loaded = false;
        this.unsubscribe = onModalShow(this.modalValue, () => this.loadOnce());
        if (isModalShown(this.modalValue)) this.loadOnce();
    }

    disconnect() {
        if (this.unsubscribe) this.unsubscribe();
    }

    loadOnce() {
        if (this.loaded) return;
        this.loaded = true;
        this.load(this.constructor.root.getRegion());
    }

    async load(regionId) {
        try {
            const url = this.urlValue.replace('__ID__', encodeURIComponent(regionId));
            const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            this.element.innerHTML = await response.text();
        } catch (error) {
            this.loaded = false;
        }
    }

    changeRegion(event) {
        this.load(event.target.value);
    }

    filter() {
        const term = this.searchTarget.value.toLowerCase();
        this.itemTargets.forEach((item) => {
            item.classList.toggle(this.hiddenClass, term !== '' && !item.dataset.name.includes(term));
        });
    }
}
